import { put, takeEvery } from "redux-saga/effects";
import { GET_APP_CONTEXT, GET_APP_CONTEXT_SUCCESS, GET_THEME_CONTEXT, GET_THEME_CONTEXT_SUCCESS } from "src/actions/exoContext";
import { upsertExoAppContext, upsertExoTheme } from "src/ducks/exoContext";
import { getExoHandler } from "src/routes/helper";

export function* handleGetAppContext() {
    const appContext = yield getExoHandler("project",null,"context","textkit");
    yield put({ type: GET_APP_CONTEXT_SUCCESS, payload: appContext });
}

export function* handleGetThemeContext() {
    const theme = yield getExoHandler("product","textkit","context","theme");
    yield put({ type: GET_THEME_CONTEXT_SUCCESS, payload: theme });
    
}

export function* handleGetThemeContextSuccess(action) {
    yield put(upsertExoTheme(action.payload));
}

export function* handleGetAppContextSuccess(action) {
    yield put(upsertExoAppContext(action.payload));
}

export default function* exoContextSaga() {
    yield takeEvery(GET_THEME_CONTEXT, handleGetThemeContext);
    yield takeEvery(GET_APP_CONTEXT, handleGetAppContext);
    yield takeEvery(GET_APP_CONTEXT_SUCCESS, handleGetAppContextSuccess);
    yield takeEvery(GET_THEME_CONTEXT_SUCCESS, handleGetThemeContextSuccess);
}


